module.exports = __webpack_public_path__ + "img/biaoqian_dianxingjingqinganli.cdc2689b.png";